import { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLinkClick = () => {
    setMenuOpen(false);
  };

  const linkStyles = "block py-2  rounded-md  transition-colors duration-700 hover:text-orange-500 hover:scale-5";

  return (
    <header className="sticky top-0 z-50 w-full border-b border-blue-900/50 bg-[#1A3D6D]/95 backdrop-blur-md shadow-sm transition-all">
      {/* Container switches layout at lg (1024px) instead of md to comfortably clear iPads */}
      <div className="flex flex-col justify-between px-4 py-4 mx-auto max-w-7xl lg:flex-row lg:items-center sm:px-6 lg:px-8">
        
        {/* Logo Area */}
        <div className="flex items-center justify-between w-full lg:w-auto">
          <Link to="/" className="flex items-center gap-3 group">
            <img 
              src="/images/logo.jpg" 
              className="object-cover w-10 h-10 transition-transform duration-200 border-2 rounded-full border-blue-400/30 group-hover:scale-105" 
              alt="Logo" 
            />
            <h2 className="text-xl font-bold tracking-tight text-blue-200 transition-colors group-hover:text-white whitespace-nowrap">
              New World Surveyor
            </h2>
          </Link>
          
          {/* Hamburger button visible on all phones AND iPads (hidden only on lg screens) */}
          <button 
            onClick={() => setMenuOpen(!menuOpen)}
            className="block text-slate-200 lg:hidden hover:text-white focus:outline-none p-1.5 rounded-lg hover:bg-blue-800/50 transition-colors"
            aria-label="Toggle Menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {menuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Navigation Menu */}
        <nav className={`${menuOpen ? "flex" : "hidden"} lg:flex flex-col lg:flex-row w-full lg:w-auto items-center mt-1  lg:mt-0 gap-6 lg:gap-8`}>
          
          <ul className="flex flex-col w-full gap-2 font-medium text-center lg:gap-8 lg:flex-row lg:items-center text-slate-200">
            <li>
              <Link to='/' onClick={handleLinkClick} className={linkStyles}>Home</Link>
            </li>
            <li>
              <Link to='/Landing' onClick={handleLinkClick} className={linkStyles}>Services</Link>
            </li>
            <li>
              <Link to='/about' onClick={handleLinkClick} className={linkStyles}>About Us</Link>
            </li>
          </ul>

          <div className="w-full h-px my-1 bg-blue-800/60 lg:hidden" />

          {/* Action Buttons setup to stack cleanly on mobile/tablet views */}
          <div className="flex flex-col w-full gap-3 text-center lg:flex-row lg:items-center lg:w-auto ">
            <Link 
              to='/login' 
              onClick={handleLinkClick} 
              className="px-5 py-2 text-sm font-semibold no-underline transition-all duration-200 border border-transparent rounded-full text-slate-200 hover:text-white hover:bg-blue-800/40 hover:border-blue-700/50"
            >
              Login
            </Link>
            <Link 
              to='/regist' 
              onClick={handleLinkClick} 
              className="px-5 py-2 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-500 rounded-full transition-all duration-200 shadow-md active:scale-[0.98] no-underline"
            >
              Register
            </Link>
          </div>

        </nav>
      </div>
    </header>
  );
}

export default Header;